import { EventBus } from '@/game/GameComponents/PhaserGame/EventBus';
import StudentGame from '@/game/GameComponents/PhaserGame/StudentGames/StudentGame';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import SequencedMinigameCardLayoutGroup from '@/game/GameComponents/PhaserGame/Utils/PhaserLayout/SequencedMinigameCardLayoutGroup';
import SlottedMinigameCardLayoutGroup from '@/game/GameComponents/PhaserGame/Utils/PhaserLayout/SlottedMinigameCardLayoutGroup';
import StudentGameCard from '@/game/prefabs/StudentGame/StudentGameCard';

export class StudentGameClickToPlaceInputHandler {
  constructor(private studentGame: StudentGame) {
    this.setupClickToPlace();
  }

  setupClickToPlace() {}

  handleCardClicked(card: StudentGameCard, forced?: boolean) {
    const cardDropSite = this.studentGame.getDropSiteFromCard(card);
    if (!cardDropSite) return;
    const targetDropSite =
      cardDropSite.siteName === 'board'
        ? this.studentGame.getHandDropSite()
        : this.studentGame.getBoardDropSite();
    if (!targetDropSite) return;
    let firstAvailableIndex = -1;
    if (targetDropSite.layoutGroup instanceof SlottedMinigameCardLayoutGroup) {
      firstAvailableIndex = targetDropSite.layoutGroup!.cards.findIndex(
        (c) => c === null || !(c instanceof StudentGameCard),
      );
    } else if (
      targetDropSite.layoutGroup instanceof SequencedMinigameCardLayoutGroup
    ) {
      firstAvailableIndex = targetDropSite.layoutGroup!.cards.length;
    }
    if (firstAvailableIndex === -1) return;
    cardDropSite.transferCard(card, targetDropSite, firstAvailableIndex);
    if (!forced) {
      this.studentGame.setSubmissionPossible(this.studentGame.getCanSubmit());
    }
    EventBus.emit(GAME_EVENTS.MINIGAME_CARD_DROPPED, {
      card,
      dropSiteName: targetDropSite.siteName,
      targetIndex: firstAvailableIndex,
    });
  }
}
